import React from "react";
const Datenschutz = () => {
  return (
    <div className="text-center">

      <h2>Datenschutzerklärung</h2>{" "}
      <p>
        Personenbezogene Daten (nachfolgend zumeist nur „Daten“ genannt) werden
        von uns nur im Rahmen der Erforderlichkeit sowie zum Zwecke der
        Bereitstellung eines funktionsfähigen und nutzerfreundlichen
        Internetauftritts, inklusive seiner Inhalte und der dort angebotenen
        Leistungen, verarbeitet.
      </p>{" "}
      <p>
        Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der
        Datenschutz-Grundverordnung (nachfolgend nur „DSGVO“ genannt), gilt als
        „Verarbeitung“ jeder mit oder ohne Hilfe automatisierter Verfahren
        ausgeführter Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit
        personenbezogenen Daten, wie das Erheben, das Erfassen, die
        Organisation, das Ordnen, die Speicherung, die Anpassung oder
        Veränderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung
        durch Übermittlung, Verbreitung oder eine andere Form der
        Bereitstellung, den Abgleich oder die Verknüpfung, die Einschränkung,
        das Löschen oder die Vernichtung.
      </p>{" "}
      <p>
        Mit der nachfolgenden Datenschutzerklärung informieren wir Sie
        insbesondere über Art, Umfang, Zweck, Dauer und Rechtsgrundlage der
        Verarbeitung personenbezogener Daten, soweit wir entweder allein oder
        gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung
        entscheiden. Zudem informieren wir Sie nachfolgend über die von uns zu
        Optimierungszwecken sowie zur Steigerung der Nutzungsqualität
        eingesetzten Fremdkomponenten, soweit hierdurch Dritte Daten in wiederum
        eigener Verantwortung verarbeiten.
      </p>{" "}
      <p>Unsere Datenschutzerklärung ist wie folgt gegliedert:</p>{" "}
      <p>
        I. Informationen über uns als Verantwortliche
        <br />
        II. Rechte der Nutzer und Betroffenen
        <br />
        III. Informationen zur Datenverarbeitung
      </p>{" "}
      <h3>I. Informationen über uns als Verantwortliche</h3>{" "}
      <p>
        Verantwortlicher Anbieter dieses Internetauftritts im
        datenschutzrechtlichen Sinne ist:
      </p>{" "}
      [Firma]
      <br />
      [Vorname, Nachname]
      <br />
      [Straße, Hausnummer]
      <br />
      [Postleitzahl, Ort]{" "}
      <p>
        Telefon: [Telefonnummer]
        <br />
        Telefax: [Faxnummer]
        <br />
        E-Mail: [E-Mail]{" "}
      </p>
      <p>Datenschutzbeauftragte/r beim Anbieter ist:</p> [DSB – Vorname,
      Nachname]
      <br />
      Telefon: [DSB – Telefonnummer]
      <br />
      Telefax: [DSB – Faxnummer]
      <br />
      E-Mail: [DSB – E-Mail] [nachfolgende Angaben sind zu ergänzen, sofern ein
      Externer Datenschutzbeauftragter bestellt ist] [DSB-Extern – Straße,
      Hausnummer]
      <br />
      [DSB-Extern – Postleitzahl, Ort]{" "}
      <h3>II. Rechte der Nutzer und Betroffenen</h3>{" "}
      <p>
        Mit Blick auf die nachfolgend noch näher beschriebene Datenverarbeitung
        haben die Nutzer und Betroffenen das Recht
      </p>{" "}
      <ul>
        {" "}
        <li>
          auf Bestätigung, ob sie betreffende Daten verarbeitet werden, auf
          Auskunft über die verarbeiteten Daten, auf weitere Informationen über
          die Datenverarbeitung sowie auf Kopien der Daten (vgl. auch Art. 15
          DSGVO);
        </li>{" "}
        <li>
          auf Berichtigung oder Vervollständigung unrichtiger bzw.
          unvollständiger Daten (vgl. auch Art. 16 DSGVO);
        </li>{" "}
        <li>
          auf unverzügliche Löschung der sie betreffenden Daten (vgl. auch Art.
          17 DSGVO), oder, alternativ, soweit eine weitere Verarbeitung gemäß
          Art. 17 Abs. 3 DSGVO erforderlich ist, auf Einschränkung der
          Verarbeitung nach Maßgabe von Art. 18 DSGVO;
        </li>{" "}
        <li>
          auf Erhalt der sie betreffenden und von ihnen bereitgestellten Daten
          und auf Übermittlung dieser Daten an andere Anbieter/Verantwortliche
          (vgl. auch Art. 20 DSGVO);
        </li>{" "}
        <li>
          auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie der Ansicht
          sind, dass die sie betreffenden Daten durch den Anbieter unter Verstoß
          gegen datenschutzrechtliche Bestimmungen verarbeitet werden (vgl. auch
          Art. 77 DSGVO).
        </li>{" "}
      </ul>{" "}
      <p>
        Darüber hinaus ist der Anbieter dazu verpflichtet, alle Empfänger, denen
        gegenüber Daten durch den Anbieter offengelegt worden sind, über jedwede
        Berichtigung oder Löschung von Daten oder die Einschränkung der
        Verarbeitung, die aufgrund der Artikel 16, 17 Abs. 1, 18 DSGVO erfolgt,
        zu unterrichten. Diese Verpflichtung besteht jedoch nicht, soweit diese
        Mitteilung unmöglich oder mit einem unverhältnismäßigen Aufwand
        verbunden ist. Unbeschadet dessen hat der Nutzer ein Recht auf Auskunft
        über diese Empfänger.
      </p>{" "}
      <p>
        <strong>
          Ebenfalls haben die Nutzer und Betroffenen nach Art. 21 DSGVO das
          Recht auf Widerspruch gegen die künftige Verarbeitung der sie
          betreffenden Daten, sofern die Daten durch den Anbieter nach Maßgabe
          von Art. 6 Abs. 1 lit. f) DSGVO verarbeitet werden. Insbesondere ist
          ein Widerspruch gegen die Datenverarbeitung zum Zwecke der
          Direktwerbung statthaft.
        </strong>
      </p>{" "}
      <h3>III. Informationen zur Datenverarbeitung</h3>{" "}
      <p>
        Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten werden
        gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt, der
        Löschung der Daten keine gesetzlichen Aufbewahrungspflichten
        entgegenstehen und nachfolgend keine anderslautenden Angaben zu
        einzelnen Verarbeitungsverfahren gemacht werden.
      </p>{" "}
      <h4 class="jet-listing-dynamic-field__content">
        Kundenkonto / Registrierungsfunktion
      </h4>
      <p>
        Falls Sie über unseren Internetauftritt ein Kundenkonto bei uns anlegen,
        werden wir die von Ihnen bei der Registrierung eingegebenen Daten (also
        bspw. Ihren Namen, Ihre Anschrift oder Ihre E-Mail-Adresse)
        ausschließlich für vorvertragliche Leistungen, für die Vertragserfüllung
        oder zum Zwecke der Kundenpflege (bspw. um Ihnen eine Übersicht über
        Ihre bisherigen Bestellungen bei uns zur Verfügung zu stellen oder um
        Ihnen die sog. Merkzettelfunktion anbieten zu können) erheben und
        speichern. Gleichzeitig speichern wir dann die IP-Adresse und das Datum
        Ihrer Registrierung nebst Uhrzeit. Eine Weitergabe dieser Daten an
        Dritte erfolgt natürlich nicht.
      </p>{" "}
      <p>
        Im Rahmen des weiteren Anmeldevorgangs wird Ihre Einwilligung in diese
        Verarbeitung eingeholt und auf diese Datenschutzerklärung verwiesen. Die
        dabei von uns erhobenen Daten werden ausschließlich für die
        Zurverfügungstellung des Kundenkontos verwendet.
      </p>{" "}
      <p>
        Soweit Sie in diese Verarbeitung einwilligen, ist Art. 6 Abs. 1 lit. a)
        DSGVO Rechtsgrundlage für die Verarbeitung.
      </p>{" "}
      <p>
        Sofern die Eröffnung des Kundenkontos zusätzlich auch vorvertraglichen
        Maßnahmen oder der Vertragserfüllung dient, so ist Rechtsgrundlage für
        diese Verarbeitung auch noch Art. 6 Abs. 1 lit. b) DSGVO.
      </p>{" "}
      <p>
        Die uns erteilte Einwilligung in die Eröffnung und den Unterhalt des
        Kundenkontos können Sie gemäß Art. 7 Abs. 3 DSGVO jederzeit mit Wirkung
        für die Zukunft widerrufen. Hierzu müssen Sie uns lediglich über Ihren
        Widerruf in Kenntnis setzen.
      </p>{" "}
      <p>
        Die insoweit erhobenen Daten werden gelöscht, sobald die Verarbeitung
        nicht mehr erforderlich ist. Hierbei müssen wir aber steuer- und
        handelsrechtliche Aufbewahrungsfristen beachten.
      </p>{" "}
      <h4 class="jet-listing-dynamic-field__content">
        Nutzerbeiträge, Kommentare und Bewertungen
      </h4>
      <p>
        Wir bieten Ihnen an, auf unseren Internetseiten Fragen, Antworten,
        Meinungen oder Bewertungen, nachfolgend nur „Beiträge genannt, zu
        veröffentlichen. Sofern Sie dieses Angebot in Anspruch nehmen,
        verarbeiten und veröffentlichen wir Ihren Beitrag, Datum und Uhrzeit der
        Einreichung sowie das von Ihnen ggf. genutzte Pseudonym.
      </p>{" "}
      <p>
        Rechtsgrundlage hierbei ist Art. 6 Abs. 1 lit. a) DSGVO. Die
        Einwilligung können Sie gemäß Art. 7 Abs. 3 DSGVO jederzeit mit Wirkung
        für die Zukunft widerrufen. Hierzu müssen Sie uns lediglich über Ihren
        Widerruf in Kenntnis setzen.
      </p>{" "}
      <p>
        Darüber hinaus verarbeiten wir auch Ihre IP- und E-Mail-Adresse. Die
        IP-Adresse wird verarbeitet, weil wir ein berechtigtes Interesse daran
        haben, weitere Schritte einzuleiten oder zu unterstützen, sofern Ihr
        Beitrag in Rechte Dritter eingreift und/oder er sonst wie rechtswidrig
        erfolgt.
      </p>{" "}
      <p>
        Rechtsgrundlage ist in diesem Fall Art. 6 Abs. 1 lit. f) DSGVO. Unser
        berechtigtes Interesse liegt in der ggf. notwendigen Rechtsverteidigung.
      </p>{" "}
      <h4 class="jet-listing-dynamic-field__content">Serverdaten</h4>
      <p>
        Aus technischen Gründen, insbesondere zur Gewährleistung eines sicheren
        und stabilen Internetauftritts, werden Daten durch Ihren
        Internet-Browser an uns bzw. an unseren Webspace-Provider übermittelt.
        Mit diesen sog. Server-Logfiles werden u.a. Typ und Version Ihres
        Internetbrowsers, das Betriebssystem, die Website, von der aus Sie auf
        unseren Internetauftritt gewechselt haben (Referrer URL), die Website(s)
        unseres Internetauftritts, die Sie besuchen, Datum und Uhrzeit des
        jeweiligen Zugriffs sowie die IP-Adresse des Internetanschlusses, von
        dem aus die Nutzung unseres Internetauftritts erfolgt, erhoben.
      </p>{" "}
      <p>
        Diese so erhobenen Daten werden vorrübergehend gespeichert, dies jedoch
        nicht gemeinsam mit anderen Daten von Ihnen.
      </p>{" "}
      <p>
        Diese Speicherung erfolgt auf der Rechtsgrundlage von Art. 6 Abs. 1 lit.
        f) DSGVO. Unser berechtigtes Interesse liegt in der Verbesserung,
        Stabilität, Funktionalität und Sicherheit unseres Internetauftritts.
      </p>{" "}
      <p>
        Die Daten werden spätestens nach sieben Tage wieder gelöscht, soweit
        keine weitere Aufbewahrung zu Beweiszwecken erforderlich ist.
        Andernfalls sind die Daten bis zur endgültigen Klärung eines Vorfalls
        ganz oder teilweise von der Löschung ausgenommen.
      </p>{" "}
      <h4 class="jet-listing-dynamic-field__content">
        Allgemeine Verlinkung auf Profile bei Drittanbietern
      </h4>
      <p>
        Der Anbieter setzt auf der Website eine Verlinkung auf die nachstehend
        aufgeführten sozialen Netzwerke ein.
      </p>{" "}
      <p>
        Rechtsgrundlage ist hierbei Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte
        Interesse des Anbieters besteht an der Verbesserung der Nutzungsqualität
        der Website.
      </p>{" "}
      <p>
        Die Einbindung der Plugins erfolgt dabei über eine verlinkte Grafik.
        Erst durch einen Klick auf die entsprechende Grafik wird der Nutzer zu
        dem Dienst des jeweiligen sozialen Netzwerks weitergeleitet.
      </p>{" "}
      <p>
        Nach der Weiterleitung des Kunden werden durch das jeweilige Netzwerk
        Informationen über den Nutzer erfasst. Dies sind zunächst Daten wie
        IP-Adresse, Datum, Uhrzeit und besuchte Seite. Ist der Nutzer
        währenddessen in seinem Benutzerkonto des jeweiligen Netzwerks
        eingeloggt, kann der Netzwerk-Betreiber ggf. die gesammelten
        Informationen des konkreten Besuches des Nutzers dem persönlichen
        Account des Nutzers zuordnen. Interagiert der Nutzer über einen
        „Teilen“-Button des jeweiligen Netzwerks, können diese Informationen in
        dem persönlichen Benutzerkonto des Nutzers gespeichert und ggf.
        veröffentlicht werden. Will der Nutzer verhindern, dass die gesammelten
        Informationen unmittelbar seinem Benutzerkonto zugeordnet werden, muss
        sich der Nutzer vor dem Anklicken der Grafik ausloggen. Zudem besteht
        die Möglichkeit, das jeweilige Benutzerkonto entsprechend zu
        konfigurieren.
      </p>{" "}
      <p>Folgende soziale Netzwerke sind vom Anbieter verlinkt:</p>{" "}
      <h4 class="jet-listing-dynamic-field__content">FontAwesome</h4>
      <p>
        Um Schriften und visuelle Elemente unseres Internetauftritts darstellen
        zu können, setzen wir die externen Schriftarten von FontAwesome ein. Bei
        FontAwesome handelt es sich um einen Dienst der
      </p>{" "}
      <p>
        Fonticons Inc., 6 Porter Road, Apartment 3R, Cambridge, MA 02140, USA,
        nachfolgend nur „FontAwesome“ genannt.
      </p>{" "}
      <p>
        Bei dem Aufruf unseres Internetauftritts wird eine Verbindung zum Server
        von FontAwesome in den USA aufgebaut, um so die Darstellung von
        Schriften und visuellen Elemente zu ermöglichen und zu aktualisieren.
      </p>{" "}
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes
        Interesse liegt in der Optimierung und dem wirtschaftlichen Betrieb
        unseres Internetauftritts.
      </p>{" "}
      <p>
        Durch die bei Aufruf unseres Internetauftritts hergestellte Verbindung
        zum Server von FontAwesome kann FontAwesome ermitteln, von welcher
        Website Ihre Anfrage gesendet worden ist und an welche IP-Adresse die
        Darstellung der Schrift zu übermitteln ist.
      </p>{" "}
      <p>FontAwesome bietet unter</p>{" "}
      <p>
        <a
          href="https://fontawesome.com/privacy"
          target="_blank"  rel="noreferrer" 
        >
          https://fontawesome.com/privacy
        </a>
      </p>{" "}
      <p>
        weitere Informationen an und zwar insbesondere zu den Möglichkeiten der
        Unterbindung der Datennutzung.
      </p>{" "}
      <h4 class="jet-listing-dynamic-field__content">Google Fonts</h4>
      <p>
        In unserem Internetauftritt setzen wir Google Fonts zur Darstellung
        externer Schriftarten ein. Es handelt sich hierbei um einen Dienst der
        Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland,
        nachfolgend nur „Google“ genannt.
      </p>{" "}
      <p>
        Um die Darstellung bestimmter Schriften in unserem Internetauftritt zu
        ermöglichen, wird bei Aufruf unseres Internetauftritts eine Verbindung
        zu dem Google-Server in den USA aufgebaut.
      </p>{" "}
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes
        Interesse liegt in der Optimierung und dem wirtschaftlichen Betrieb
        unseres Internetauftritts.
      </p>{" "}
      <p>
        Durch die bei Aufruf unseres Internetauftritts hergestellte Verbindung
        zu Google kann Google ermitteln, von welcher Website Ihre Anfrage
        gesendet worden ist und an welche IP-Adresse die Darstellung der Schrift
        zu übermitteln ist.
      </p>{" "}
      <p>Google bietet unter</p>{" "}
      <p>
        <a
          href="https://adssettings.google.com/authenticated"
          target="_blank"
          rel="noreferrer" 
        >
          https://adssettings.google.com/authenticated
        </a>
      </p>{" "}
      <p>
        <a
          href="https://policies.google.com/privacy"
          target="_blank"
          rel="noreferrer" 
        >
          https://policies.google.com/privacy
        </a>
      </p>{" "}
      <p>
        weitere Informationen an und zwar insbesondere zu den Möglichkeiten der
        Unterbindung der Datennutzung.
      </p>{" "}
      <h4 class="jet-listing-dynamic-field__content">jQuery CDN</h4>
      <p>
        Zur Optimierung der Abrufgeschwindigkeit, der Gestaltung und Darstellung
        der Inhalte unseres Internetauftritts auf unterschiedlichen Endgeräten
        setzen wir in unserem Internetauftritt den Dienst
      </p>{" "}
      <p>
        jQuery CDN, ein Content Delivery Network („CDN“), ein. Hierbei handelt
        es sich um einen Dienst der jQuery Foundation, nachfolgend nur „jQuery“
        genannt. jQuery wird für die JS Foundation über das StackPath CDN
        verteilt.
      </p>{" "}
      <p>
        Um die Inhalte unseres Internetauftritts schnell ausliefern zu können,
        greift der Dienst auf sog. JavaScript-Bibliotheken zurück. Dabei werden
        entsprechende Dateien von dem CDN-Server geladen, soweit sie nicht schon
        durch einen Besuch eines anderen Internetauftritts in Ihrem
        Browser-Cache vorhanden sind. Im Falle der Verbindung zu dem CDN-Server
        wird Ihre IP-Adresse erfasst. Dabei kann nicht ausgeschlossen werden,
        dass eine Verbindung zu einem Server außerhalb der EU erfolgt.
      </p>{" "}
      <p>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes
        Interesse liegt in der Beschleunigung der Ladezeiten unseres
        Internetauftritts sowie in dessen Optimierung.
      </p>{" "}
      <p>
        Um die Ausführung des Java-Script-Codes von jQuery insgesamt zu
        verhindern, können Sie einen sog. Java-Script-Blocker installieren, wie
        bspw. noscript.net oder ghostery.com. Sollten Sie die Ausführung des
        Java-Script-Codes verhindern oder einschränken, kann dies aus
        technischen Gründen allerdings dazu führen, dass womöglich nicht
        sämtliche Inhalte und Funktionen unseres Internetauftritts verfügbar
        sind.
      </p>{" "}
      <h4 class="jet-listing-dynamic-field__content">OpenStreetMap</h4>
      <p>
        Für Anfahrtsbeschreibungen setzen wir OpenStreetMap, einen Dienst der
        OpenStreetMap Foundation, St John’s Innovation Centre, Cowley Road,
        Cambridge, CB 4 0 WS, United Kingdom, nachfolgend nur „OpenStreetMap“
        genannt, ein.
      </p>{" "}
      <p>
        Bei Aufruf einer unserer Internetseiten, in die der Dienst OpenStreetMap
        eingebunden ist, wird durch OpenStreetMap ein Cookie über Ihren
        Internet-Browser auf Ihrem Endgerät gespeichert. Hierdurch werden Ihre
        Nutzereinstellungen und Nutzerdaten zum Zwecke der Anzeige der Seite
        bzw. zur Gewährleistung der Funktionalität des Dienstes OpenStreetMap
        verarbeitet. Durch diese Verarbeitung kann OpenStreetMap erkennen, von
        welcher Internetseite Ihre Anfrage gesendet worden ist und an welche IP-
        Adresse die Darstellung der Anfahrt übermittelt werden soll.
      </p>{" "}
      <p>
        Im Falle einer von Ihnen erteilten Einwilligung für diese Verarbeitung
        ist Rechtsgrundlage Art. 6 Abs. 1 lit. a DSGVO. Rechtsgrundlage kann
        auch Art. 6 Abs. 1 lit. f DSGVO sein. Unser berechtigtes Interesse liegt
        in der Optimierung und dem wirtschaftlichen Betrieb unseres
        Internetauftritts.
      </p>{" "}
      <p>
        Sofern Sie mit dieser Verarbeitung nicht einverstanden sind, haben Sie
        die Möglichkeit, die Installation der Cookies durch die entsprechenden
        Einstellungen in Ihrem Internet-Browser zu verhindern. Einzelheiten
        hierzu finden Sie vorstehend unter dem Punkt „Cookies“.
      </p>{" "}
      <p>OpenStreetMap bietet unter</p>{" "}
      <p>
        <a
          href="https://wiki.osmfoundation.org/wiki/Privacy_Policy"
          target="_blank"
          rel="noreferrer" 
        >
          https://wiki.osmfoundation.org/wiki/Privacy_Policy
        </a>
      </p>{" "}
      <p>
        weitere Informationen zur Erhebung und Nutzung der Daten sowie zu Ihren
        Rechten und Möglichkeiten zum Schutz Ihrer Privatsphäre an.
      </p>{" "}
      <p>
        <a
          href="https://www.generator-datenschutzerklärung.de"
          target="_blank"
          rel="noreferrer" 
        >
          Muster-Datenschutzerklärung
        </a>{" "}
        der{" "}
        <a
          href="https://www.ratgeberrecht.eu/datenschutz/datenschutzerklaerung-generator-dsgvo.html"
          target="_blank"
          rel="noreferrer" 
        >
          Anwaltskanzlei Weiß &amp; Partner
        </a>
      </p>
    </div>
  );
};

export default Datenschutz;
